import * as LocalStorageKey from "../const/localStorage.key.js"
import { createBrowserHistory } from 'history';
import Cookies from 'js-cookie'
import { MIM_types_of_files, MIM_types_of_images, type_of_uploads } from "../data/warhouse";

//
export const iconStyle = (Icon) => <Icon />

//Save Cookie data here
export const setCookie = (name, value, minutes) => {
    let inFifteenMinutes = new Date(new Date().getTime() + minutes * 60 * 1000)
    Cookies.set(name, value, { expires: inFifteenMinutes, path: '/', secure: true })
}
export const getCookie = (name) => {
    return Cookies.get(name)
}
export const removeCookie = (name) => {
    return Cookies.remove(name)
}
//
export const getToken = localStorage.getItem(LocalStorageKey.USER_KEY)
                        ?getCookie(LocalStorageKey.USER_KEY)
                          ?JSON.parse(getCookie(LocalStorageKey.USER_KEY))
                          :null
                        :null
export const getRole = localStorage.getItem(LocalStorageKey.USER_KEY)
                      ?getCookie(LocalStorageKey.USER_ROLE)
                        ?JSON.parse(getCookie(LocalStorageKey.USER_ROLE))
                        :null
                      : null
export const getPermissions = localStorage.getItem(LocalStorageKey.USER_KEY)
                              ?getCookie(LocalStorageKey.USER_PERMISSIONS)
                                ?JSON.parse(localStorage.getItem(LocalStorageKey.USER_PERMISSIONS))
                                :null
                              :null
export const getTypeOfAccount = localStorage.getItem(LocalStorageKey.USER_TYPE_OF_ACCOUNT)
                                ?getCookie(LocalStorageKey.USER_TYPE_OF_ACCOUNT)
                                  ?JSON.parse(getCookie(LocalStorageKey.USER_TYPE_OF_ACCOUNT))
                                  :null
                                :null
export const getFullName = localStorage.getItem(LocalStorageKey.USER_FULL_NAME)
                                ?getCookie(LocalStorageKey.USER_FULL_NAME)
                                  ?JSON.parse(getCookie(LocalStorageKey.USER_FULL_NAME))
                                  :null
  : null
                                                         
export const configHeaders={
                            headers: 
                                    { 
                                      "authorization": `bearer ${getToken}`, 
                                      'Content-Type': 'application/json',
                                    },
                            withCredentials:true
}

export const history = createBrowserHistory();

export function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data ||
    error?.message ||
    error.toString()
  );
}
//used in the reducer to delete a object                        
export const removeObjectWithId = (arr, id) => {
  console.log("arr to delete", arr)
  const objWithIdIndex = arr.findIndex((obj) => obj.id === id)
  arr.splice(objWithIdIndex, 1)

  return arr
}
//used in the reducer to find object by id from an array
export const findObjectFromArrayWithId = (arr, id) => {
  console.log("findObjectFromArrayWithId", arr)
  console.log("findObjectFromArrayWithId",id)
  const index = arr.findIndex((obj) => obj.id === id)
  return index
}

export const checkTheAuthorization=(error)=>{
  if(error.response.status===401 && error.response.statusText==="Unauthorized"){
    removeCookie(getToken)
    removeCookie(getRole)
    removeCookie(getTypeOfAccount)
    history.replace('/login');
    // window.location.href = '/login';
  }
}

export const checkExtention=(xyz, type)=>{
  if(type===type_of_uploads.Images){
    const exts= MIM_types_of_images
    if(exts.indexOf(xyz.toLowerCase())>=0)
      return true
    return false
  }
  else if(type===type_of_uploads.Files){
    const exts= MIM_types_of_files
    if(exts.indexOf(xyz.toLowerCase())>=0)
      return true
    return false
  }
}

export const replaceBy = (text, rep, repBy) => { return text.replace(rep, repBy) }
export const getTheFileByAttachmentType=(files,the_attachmenttype)=>{
   const file= files.find(file=>file.attachementtype===the_attachmenttype)
   return file
}
export const getTheFilesByAttachmentType = (files, the_attachmenttype) => {
   const matchingFiles = files.filter(file => file.attachementtype === the_attachmenttype);
   return matchingFiles;
}
export const getIndexFileByAttachmentType=(files,the_attachmenttype)=>{
   const index = files.findIndex(file => file.attachementtype === the_attachmenttype)
   return index
}
export const initializeObjectFileOrImage=(file,the_attachmenttype,base64,desc)=>{
   const theObject={
      file: file,
      fileName: file.name,
      contentType: file.type,
      attachementtype:the_attachmenttype,
      size: file.size,
      url: "",
      local:true,
      base64encoded: base64.split("base64,")[1],
      description: desc,
      notes: "",
    }
   return theObject
}

//check if permission available
export const checkUserPermissions = (permission) => {
  console.log("getPermissions", getPermissions)
  return getPermissions.some(per => per.name === permission)
}

//get the key of an object
export const getObjKey = (obj, value)=> {
  return Object.keys(obj).find(key => obj[key] === value);
}